export default __webpack_public_path__ + "static/media/3-6-4.98c3c3da.jpg";